"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
const redux_1 = require("redux");
const reducer_1 = require("./by-customer/reducer");
const reducer_2 = require("./by-property/reducer");
exports.reducer = () => redux_1.combineReducers({
    byCustomer: reducer_1.commissionDealsByCustomer,
    byProperty: reducer_2.commissionDealsByProperty
});
//# sourceMappingURL=reducer.js.map